import React from "react";
import ProviderInput from "./ProviderInput";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as AddIcon } from "../../../../assets/icons/add.svg";

const MultiFieldList = ({
  label,
  values = [""],
  placeholder = "",
  type = "text",
  onChange,
  addLabel = "Add",
  required = false,
}) => {
  const safeValues = values?.length ? values : [""];

  const updateItem = (itemIndex, value) => {
    const updatedValues = safeValues.map((item, index) =>
      index === itemIndex ? value : item,
    );

    onChange(updatedValues);
  };

  const addItem = () => {
    onChange([...safeValues, ""]);
  };

  const removeItem = (itemIndex) => {
    const updatedValues = safeValues.filter((_, index) => index !== itemIndex);

    onChange(updatedValues.length ? updatedValues : [""]);
  };

  return (
    <div className="provider-network-multi-field">
      <div className="provider-network-multi-field-header">
        <label className="provider-network-label">
          {label} {required && <span>*</span>}
        </label>
        <AddIcon className="provider-network-add-icon" onClick={addItem} />

        {/* <button
          type="button"
          className="provider-network-add-row-btn"
          onClick={addItem}
        >
                  
        </button> */}
      </div>

      <div className="provider-network-multi-field-list">
        {safeValues.map((value, itemIndex) => (
          <div
            key={`${label}-${itemIndex}`}
            className="provider-network-multi-field-row"
          >
            <ProviderInput
              type={type}
              value={value}
              placeholder={placeholder}
              onChange={(newValue) => updateItem(itemIndex, newValue)}
              className="provider-network-no-margin"
            />

            <button
              type="button"
              className="provider-network-row-delete-btn"
              onClick={() => removeItem(itemIndex)}
              disabled={safeValues.length === 1 && !value}
              title={`Delete ${label}`}
              aria-label={`Delete ${label}`}
            >
              <DeleteIcon />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiFieldList;
